import { render, staticRenderFns } from "./popover-preview.vue?vue&type=template&id=36ddf9ce"
import script from "./popover-preview.vue?vue&type=script&lang=js"
export * from "./popover-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ddf9ce')) {
      api.createRecord('36ddf9ce', component.options)
    } else {
      api.reload('36ddf9ce', component.options)
    }
    module.hot.accept("./popover-preview.vue?vue&type=template&id=36ddf9ce", function () {
      api.rerender('36ddf9ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabPrizeView/components/NotVeryCompatible/popover-preview.vue"
export default component.exports